import axios from 'axios'
import { apiConfigAuthenticated } from '@/api/config'

/**
 *  Метод для получения объектов по договору.
 */

export let apiGetObjects = function (token) {
  return axios.get('/api/v0/statistic/objects/', apiConfigAuthenticated(token))
}

export let apiUpdateObject = function (data, token) {
  return axios.post('/api/v0/statistic/object-rename/',
    data,
    apiConfigAuthenticated(token))
}

/**
 *  Методы для подключения/отключения объектов в разделе `Управление объектами`.
 */

export let apiActivateObject = function (arrID, token) {
  return axios.post('/api/v0/statistic/object-activate/',
    arrID,
    apiConfigAuthenticated(token))
}

export let apiDeactivateObject = function (arrID, token) {
  return axios.post('/api/v0/statistic/object-deactivate/',
    arrID,
    apiConfigAuthenticated(token))
}



// WEBPACK FOOTER //
// ./src/api/objects.js